import { MARQUEE_ITEMS } from "@/lib/site";

export default function Marquee({ dark = true }) {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${
        dark
          ? "bg-teal-obsidian border-teal-brand/40 py-5"
          : "bg-gold-soft border-gold/20 py-5"
      }`}
    >
      <div className="marquee-track">
        {items.map((item, i) => (
          <span
            key={i}
            aria-hidden={i >= MARQUEE_ITEMS.length}
            className={`flex items-center shrink-0 gap-6 px-6 font-display text-xl sm:text-2xl italic font-medium whitespace-nowrap ${
              dark ? "text-alabaster/85" : "text-teal-brand"
            }`}
          >
            {item}
            <svg width="14" height="14" viewBox="0 0 14 14" className="shrink-0" aria-hidden="true">
              <circle cx="7" cy="7" r="4" fill="#C59B27" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
